/**
 * Navigare hub ↔ popup modal în Configurare interfață client.
 */
import { logger } from '../utils/logger.js?v=83.79';
import { hasFeature, featureLockedMessage } from '../config/plans.js?v=83.79';
import { showSnackbar } from '../utils/ui.js?v=83.79';
import { syncClientPromoFieldsVisibility, hydrateClientPromoGalleryAdminFromSettings, getCurrentSettings } from '../services/settings.js?v=83.79';

const SUBSECTION_LABELS = {
  images: 'Imagini interfață',
  'social-media': 'Social media',
  feedback: 'Recenzie Google',
  'location-menu': 'Configurare modul meniu',
  'location-hours': 'Program locație',
  reservation: 'Configurare modul contact',
  'location-map': 'Locație / Hartă',
  'wifi-info': 'WiFi locație',
  'community-page': 'Comunitate',
  'location-logo': 'Logo locație',
  'client-promo-gallery': 'Galerie promo client',
  admin: 'Panou Admin',
  prizes: 'Recompense',
  'advanced-claims': 'Revendicări avansate',
  noWin: 'Mesaj necâștigător',
  'event-module': 'Eveniment',
  'loyalty-module': 'Fidelizare'
};

/* Antetul ferestrelor de editare (stil „Pagina mea”): iconița modulului pe pătrat verde-mentă + titlul scurt,
   aceleași ca în lista „Ce vede clientul”. Doar aspect: nu atinge câmpurile și salvarea. */
const MODULE_ICON_PATHS = {
  'location-menu': '<path d="M4 4h16v16H4z"/><path d="M8 9h8M8 13h8M8 17h5"/>',
  'location-hours': '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
  'location-map': '<path d="M12 21s-7-6.2-7-11.5a7 7 0 0 1 14 0C19 14.8 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.5"/>',
  'wifi-info': '<path d="M5 12.5a10 10 0 0 1 14 0"/><path d="M8.5 16a5 5 0 0 1 7 0"/><path d="M2 9a15 15 0 0 1 20 0"/><circle cx="12" cy="19.5" r="1"/>',
  reservation: '<path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.4 1.8.7 2.7a2 2 0 0 1-.5 2.1L8 9.8a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.7.7a2 2 0 0 1 1.7 2z"/>',
  feedback: '<path d="m12 2 3.1 6.3 6.9 1-5 4.9 1.2 6.8L12 17.8 5.8 21l1.2-6.8-5-4.9 6.9-1z"/>',
  'social-media': '<rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="4"/>',
  images: '<rect x="3" y="3" width="18" height="18" rx="3"/><circle cx="9" cy="9" r="2"/><path d="m21 15-5-5L5 21"/>',
  'location-logo': '<circle cx="12" cy="9" r="6"/><path d="M8.5 14 7 22l5-3 5 3-1.5-8"/>',
  'client-promo-gallery': '<rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M5 12v9h14v-9M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5"/>',
  'community-page': '<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>',
  campanie: '<path d="M8 21h8M12 17v4M7 4h10v5a5 5 0 0 1-10 0z"/><path d="M17 5h3v2a3 3 0 0 1-3 3M7 5H4v2a3 3 0 0 0 3 3"/>',
  prizes: '<rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M5 12v9h14v-9M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5"/>',
  'event-module': '<rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/>',
  'loyalty-module': '<path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1.1L12 21l7.8-7.5 1-1.1a5.5 5.5 0 0 0 0-7.8z"/>'
};
const MODULE_SHORT_TITLES = {
  'location-menu': 'Meniu',
  'location-hours': 'Program',
  'location-map': 'Locație',
  'wifi-info': 'WiFi',
  reservation: 'Contact',
  'social-media': 'Rețele sociale',
  images: 'Poze local',
  'location-logo': 'Logo',
  'client-promo-gallery': 'Oferte',
  'community-page': 'Comunitate'
};
function setModalModuleIcon(id) {
  try {
    const head = document.querySelector('#clientInterfaceModulePopup .client-interface-module-popup__head');
    const title = getModalTitleEl();
    if (!head || !title) return;
    let tile = head.querySelector('.ci-mod-icon');
    const paths = MODULE_ICON_PATHS[id];
    if (!paths) { if (tile) tile.hidden = true; return; }
    if (!tile) {
      tile = document.createElement('span');
      tile.className = 'ci-mod-icon';
      tile.setAttribute('aria-hidden', 'true');
      title.before(tile);
    }
    tile.hidden = false;
    tile.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${paths}</svg>`;
  } catch (_) { /* doar aspect */ }
}
function moduleTitleFor(id) {
  const s = getCurrentSettings?.() || {};
  if (id === 'location-menu' && String(s.menuLabel || '').trim()) return String(s.menuLabel).trim();
  if (id === 'reservation' && String(s.reservationLabel || '').trim()) return String(s.reservationLabel).trim();
  if (id === 'client-promo-gallery' && String(s.clientPromoGallery?.title || '').trim()) return String(s.clientPromoGallery.title).trim();
  return MODULE_SHORT_TITLES[id] || SUBSECTION_LABELS[id] || id;
}

const EDITABLE_SECTION_MAP = {
  promo: 'client-promo-gallery',
  bannere: null,
  oferte: null,
  'evenimente-edit': null,
  continut: null
};

/** Numele celor două tipuri de campanie (afișate comerciantului). */
export const CAMPAIGN_NAMES = { guaranteed: 'Campanie instant', scratch: 'Răzuiește și câștigă', lottery: 'Campanie cu extragere', random: 'Campanie aleatorie' };

const CAMPAIGN_PICKER_ITEMS = [
  { id: 'prizes', title: 'Premii și poze', desc: 'Poză pentru fiecare premiu, ordine, bucăți', icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M5 12v9h14v-9M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5"/></svg>' },
  { id: 'admin', title: 'Setări campanie', desc: 'Textul butonului, perioada, limite', icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 21v-7M4 10V3M12 21v-9M12 8V3M20 21v-5M20 12V3M1 14h6M9 8h6M17 16h6"/></svg>' },
  { id: 'noWin', title: 'Mesaj necâștigător', desc: 'Text și poză pentru cine nu câștigă', icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>' },
  { id: 'advanced-claims', title: 'Revendicări', desc: 'Număr bon, responsabili', icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.9M16 3.1a4 4 0 0 1 0 7.8"/></svg>' }
];

/** @type {Map<HTMLElement, { parent: Node, next: ChildNode | null }>} */
const subsectionHomes = new Map();

/** @type {'campanie-picker' | null} */
let modalBackTarget = null;

function getPanelsRoot() {
  return document.getElementById('clientInterfacePanels');
}

function getModal() {
  return document.getElementById('clientInterfaceModulePopup');
}

function getModalBody() {
  return document.getElementById('clientInterfaceModulePopupBody');
}

function getModalPicker() {
  return document.getElementById('clientInterfaceModulePopupPicker');
}

function getModalTitleEl() {
  return document.getElementById('clientInterfaceModulePopupTitle');
}

function getModalBackBtn() {
  return document.getElementById('clientInterfaceModulePopupBackBtn');
}

function getModalSaveFooter() {
  return document.getElementById('clientInterfaceModulePopupFooter');
}

function getModalSaveBtn() {
  return document.getElementById('clientInterfaceModuleSaveBtn');
}

function getCampanieActivateBar() {
  return document.getElementById('ciModuleActivateBar');
}

function showCampanieActivateBar() {
  const bar = getCampanieActivateBar();
  if (bar) bar.hidden = false;
  import('./mod-client-modules.js?v=83.79')
    .then((m) => m.updateModClientModulesUI?.())
    .catch(() => {});
}

function hideCampanieActivateBar() {
  const bar = getCampanieActivateBar();
  if (bar) bar.hidden = true;
}

function setModalSaveModule(moduleId) {
  const footer = getModalSaveFooter();
  const btn = getModalSaveBtn();
  if (!footer || !btn) return;
  if (moduleId) {
    footer.hidden = false;
    btn.setAttribute('data-arg', moduleId);
  } else {
    footer.hidden = true;
    btn.setAttribute('data-arg', '');
  }
}

function rememberSubsectionHome(sub) {
  if (!sub || subsectionHomes.has(sub)) return;
  subsectionHomes.set(sub, {
    parent: sub.parentNode,
    next: sub.nextSibling
  });
}

function restoreSubsection(sub) {
  if (!sub) return;
  const home = subsectionHomes.get(sub);
  if (!home?.parent) return;
  if (sub.parentNode !== home.parent) {
    if (home.next && home.next.parentNode === home.parent) {
      home.parent.insertBefore(sub, home.next);
    } else {
      home.parent.appendChild(sub);
    }
  }
  sub.classList.remove('expanded', 'ci-in-modal');
}

function restoreAllModalSubsections() {
  const body = getModalBody();
  const subs = body ? [...body.querySelectorAll('.admin-subsection')] : [];
  subs.forEach(restoreSubsection);

  const legacyBody = document.getElementById('clientInterfaceDrilldownPanelBody');
  if (legacyBody) {
    [...legacyBody.querySelectorAll('.admin-subsection')].forEach(restoreSubsection);
  }
}

function findSubsection(id) {
  return document.querySelector(
    `.admin-section[data-section="client-interface"] .admin-subsection[data-subsection="${CSS.escape(id)}"]`
  );
}

function setModalBackVisible(visible) {
  const btn = getModalBackBtn();
  if (btn) btn.hidden = !visible;
}

function hidePicker() {
  const picker = getModalPicker();
  if (!picker) return;
  picker.innerHTML = '';
  picker.hidden = true;
  setModalSaveModule(null);
}

function showCampaignPicker() {
  const picker = getModalPicker();
  const body = getModalBody();
  if (!picker || !body) return;

  restoreAllModalSubsections();
  body.classList.remove('has-subsection');
  modalBackTarget = null;
  setModalBackVisible(false);

  if (getModalTitleEl()) getModalTitleEl().textContent = 'Campanie';
  setModalModuleIcon('campanie');

  picker.innerHTML = '';
  picker.hidden = false;

  const cards = buildCampaignPickerCards();
  const quick = buildQuickCampaignBlock(cards);
  // Panoul rapid are propriul buton de pornire/oprire — bara de activare de sus ar fi dublură.
  if (quick) {
    hideCampanieActivateBar();
    picker.appendChild(quick);
  } else {
    showCampanieActivateBar();
    cards.forEach((c) => picker.appendChild(c));
  }
}

/** Cardurile de personalizare (doar pentru Marele Joc). */
function buildCampaignPickerCards() {
  return CAMPAIGN_PICKER_ITEMS.map((item) => {
    const card = document.createElement('div');
    card.className = 'ci-modal-picker-card';
    card.setAttribute('role', 'button');
    card.tabIndex = 0;
    card.dataset.action = 'openClientInterfaceSubsection';
    card.dataset.arg = item.id;
    card.dataset.fromPicker = 'campanie';
    card.innerHTML = `
      <span class="ci-modal-picker-card__icon" aria-hidden="true">${item.icon}</span>
      <span class="ci-modal-picker-card__text">
        <span class="ci-modal-picker-card__title">${item.title}</span>
        <span class="ci-modal-picker-card__desc">${item.desc}</span>
      </span>
      <span class="ci-modal-picker-card__chev" aria-hidden="true"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 6 6 6-6 6"/></svg></span>
    `;
    return card;
  });
}

/* ---------- Campanie rapidă: premii gata făcute, un tap ---------- */
const QUICK_CAMPAIGN_PRESETS = [
  { id: 'cafe', label: '☕ Cafenea', prizes: [['O cafea gratuită', 20], ['10% reducere la următoarea vizită', 50]] },
  { id: 'resto', label: '🍽️ Restaurant', prizes: [['Desert din partea casei', 20], ['10% reducere la nota următoare', 40]] },
  { id: 'beauty', label: '💅 Beauty', prizes: [['15% reducere la următoarea programare', 30], ['Un tratament gratuit', 3]] },
  { id: 'shop', label: '🛍️ Magazin', prizes: [['Un produs gratuit la alegere', 10], ['10% reducere la următoarea cumpărătură', 40]] }
];

function hasRealPrizes(settings) {
  return (Array.isArray(settings?.prizes) ? settings.prizes : []).some(
    (p) => p && String(p.message || '').trim() && Number(p.count) > 0
  );
}

function quickIsoDate(daysAhead) {
  // Data din România (nu UTC) — între 00:00 și 03:00 UTC ar da ziua de ieri.
  const fmt = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Bucharest', year: 'numeric', month: '2-digit', day: '2-digit' });
  return fmt.format(new Date(Date.now() + daysAhead * 86400000));
}

const QUICK_DURATIONS = [
  { id: '7', label: '7 zile', days: 7 },
  { id: '14', label: '14 zile', days: 14 },
  { id: '30', label: '30 zile', days: 30 },
  { id: 'month', label: 'Final de lună' },
  { id: 'none', label: 'Fără final' }
];
const QUICK_TRIES = [100, 300, 500, 1000];

/** Campanie instant: campanii gata făcute (fiecare cu variante). */
const INSTANT_TEMPLATES = [
  { icon: '☕', title: 'Cafea gratis', image: '/img/rewards/cafea.svg', variants: ['O cafea din partea casei la a doua comandă', 'O cafea gratuită la următoarea vizită', 'A doua cafea la jumătate de preț'] },
  { icon: '🏷️', title: 'Reducere', image: '/img/rewards/reducere.svg', variants: ['10% reducere la următoarea vizită', '15% reducere la următoarea comandă', '20% reducere la următoarea vizită'] },
  { icon: '🎟️', title: 'Voucher', image: '/img/rewards/voucher.svg', variants: ['Voucher de 10 lei la următoarea vizită', 'Voucher de 20 lei la o comandă de peste 100 lei', 'Voucher de 25 lei la următoarea programare'] },
  { icon: '🍰', title: 'Desert gratis', image: '/img/rewards/desert.svg', variants: ['Un desert din partea casei la următoarea vizită', 'Desert gratuit la orice meniu', 'Un desert la alegere la a doua vizită'] },
  { icon: '🥤', title: 'Băutură gratis', image: '/img/rewards/bautura.svg', variants: ['O limonadă din partea casei la următoarea vizită', 'Un suc natural gratuit la orice comandă'] },
  { icon: '🎁', title: 'Produs cadou', image: '/img/rewards/cadou.svg', variants: ['Un produs mic cadou la următoarea cumpărătură', 'O mostră gratuită la orice cumpărătură'] }
];

function roToday() {
  return quickIsoDate(0);
}
function endOfMonthRo() {
  const [y, m] = roToday().split('-').map(Number);
  const last = new Date(Date.UTC(y, m, 0)).getUTCDate();
  return `${y}-${String(m).padStart(2, '0')}-${String(last).padStart(2, '0')}`;
}
function fmtRo(d) {
  return d ? String(d).split('-').reverse().join('.') : '';
}

function qcEl(tag, attrs = {}, ...kids) {
  const e = document.createElement(tag);
  Object.entries(attrs).forEach(([k, v]) => {
    if (v == null || v === false) return;
    if (k === 'class') e.className = v;
    else if (k === 'text') e.textContent = v;
    else if (k.startsWith('on') && typeof v === 'function') e.addEventListener(k.slice(2), v);
    else e.setAttribute(k, v === true ? '' : v);
  });
  kids.flat().forEach((c) => c != null && e.append(c));
  return e;
}

const QC_CSS2 = "\n/* v78.3 \u2014 Cadou Sigur / Marele Joc */\n#clientInterfaceModulePopup .ci-qc { grid-template-columns: minmax(0, 1fr); gap: 10px; padding: 14px; box-sizing: border-box; max-width: 100%; flex: none !important; overflow: visible; }\n#clientInterfaceModulePopup .ci-qc > *, #clientInterfaceModulePopup .ci-qc__g > *, #clientInterfaceModulePopup .ci-qc__l > *, #clientInterfaceModulePopup .ci-qc__common > * { min-width: 0; max-width: 100%; box-sizing: border-box; }\n#clientInterfaceModulePopup .ci-qc__title { font-size: 19px; }\n#clientInterfaceModulePopup .ci-qc__chips.ci-qc__chips--wrap { flex-wrap: wrap; overflow: visible; }\n#clientInterfaceModulePopup .ci-qc__kinds { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__kind { position: relative; display: flex !important; flex-direction: column; align-items: flex-start; justify-content: flex-start; gap: 4px; width: 100% !important; min-height: 150px !important; height: auto !important; margin: 0 !important; padding: 14px 12px 12px !important; border-radius: 18px !important; border: 2px solid #E4E2DC !important; background: #FFFFFF !important; background-image: none !important; color: #17201C !important; box-shadow: 0 1px 2px rgba(23,32,28,.04) !important; text-align: left !important; text-transform: none !important; letter-spacing: 0 !important; white-space: normal !important; transform: none !important; transition: border-color .15s, box-shadow .15s, background .15s; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__kind .ci-qc__kindicon { display: flex; align-items: center; justify-content: center; width: 44px; height: 44px; border-radius: 14px; background: #F5F4F0; font-size: 24px; line-height: 1; margin-bottom: 4px; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__kind b { font-family: 'Outfit', sans-serif; font-size: 17px; font-weight: 800; line-height: 1.15; color: #17201C; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__kind .ci-qc__kindtext { font-size: 12.5px; font-weight: 500; line-height: 1.3; color: #4A5650; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__kind .ci-qc__badge { margin-top: auto; padding: 3px 8px; border-radius: 999px; font-style: normal; font-size: 11px; font-weight: 800; line-height: 1.3; }\n#clientInterfaceModulePopup .ci-qc__badge--guaranteed { background: #E6F2EA; color: #145A37; }\n#clientInterfaceModulePopup .ci-qc__badge--lottery { background: #FFF1D6; color: #7A4B00; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__kind--guaranteed.is-on { border-color: #1E7A4C !important; background: #F1F9F4 !important; box-shadow: 0 6px 18px rgba(30,122,76,.16) !important; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__kind--guaranteed.is-on .ci-qc__kindicon { background: #1E7A4C; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__kind--lottery.is-on { border-color: #C77700 !important; background: #FFFAF0 !important; box-shadow: 0 6px 18px rgba(199,119,0,.16) !important; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__kind--lottery.is-on .ci-qc__kindicon { background: #C77700; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__kind.is-on::after { content: '\u2713'; position: absolute; top: 10px; right: 10px; width: 22px; height: 22px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 13px; font-weight: 900; color: #FFF; background: #1E7A4C; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__kind--lottery.is-on::after { background: #C77700; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__kind.is-locked { opacity: .6; }\n#clientInterfaceModulePopup .ci-qc__g[hidden], #clientInterfaceModulePopup .ci-qc__l[hidden] { display: none !important; }\n#clientInterfaceModulePopup .ci-qc__g, #clientInterfaceModulePopup .ci-qc__l, #clientInterfaceModulePopup .ci-qc__common { display: flex; flex-direction: column; gap: 8px; min-width: 0; }\n#clientInterfaceModulePopup .ci-qc__g, #clientInterfaceModulePopup .ci-qc__l { padding: 12px; border-radius: 16px; background: #FAFAF7; border: 1px solid #EEEDE8; }\n#clientInterfaceModulePopup .ci-qc__common { margin-top: 4px; }\n#clientInterfaceModulePopup .ci-qc__step { display: flex; align-items: center; gap: 8px; margin-top: 6px; font-size: 14px; font-weight: 800; color: #17201C; }\n#clientInterfaceModulePopup .ci-qc__step i { flex: none; display: flex; align-items: center; justify-content: center; width: 22px; height: 22px; border-radius: 50%; background: #17201C; color: #FFF; font-style: normal; font-size: 12px; font-weight: 800; }\n#clientInterfaceModulePopup .ci-qc--lottery .ci-qc__step i { background: #C77700; }\n#clientInterfaceModulePopup .ci-qc__notary { padding: 12px; border-radius: 14px; background: #FFF6E5; border: 1px solid #F3D9A4; color: #5C3D00; font-size: 13px; }\n#clientInterfaceModulePopup .ci-qc__notary b { display: block; font-size: 13.5px; margin-bottom: 6px; }\n#clientInterfaceModulePopup .ci-qc__notary ol { margin: 0; padding-left: 20px; display: grid; gap: 3px; line-height: 1.35; }\n#clientInterfaceModulePopup .ci-qc__row { grid-template-columns: minmax(0, 1fr) 96px 36px; }\n#clientInterfaceModulePopup .ci-qc__qtywrap span { text-transform: none !important; letter-spacing: 0 !important; }\n#clientInterfaceModulePopup .ci-qc--lottery button.ci-qc__go { background: #C77700 !important; box-shadow: 0 8px 20px rgba(199,119,0,.25) !important; }\n#clientInterfaceModulePopup .ci-qc__custom { display: grid; gap: 8px; margin-top: 4px; }\n#clientInterfaceModulePopup .ci-qc__customhead b { display: block; font-size: 15px; font-weight: 800; color: #17201C; }\n#clientInterfaceModulePopup .ci-qc__customhead span { display: block; font-size: 12.5px; color: #4A5650; margin-top: 2px; }\n#clientInterfaceModulePopup .ci-qc__custom .ci-modal-picker-card { margin: 0; background: #FFFFFF; }\n#clientInterfaceModulePopup .ci-qc__custom .ci-modal-picker-card { display: grid !important; grid-template-columns: 40px minmax(0,1fr) 16px; align-items: center; gap: 12px; padding: 12px !important; border-radius: 14px !important; border: 1px solid #E4E2DC !important; background: #FFFFFF !important; cursor: pointer; }\n#clientInterfaceModulePopup .ci-qc__custom .ci-modal-picker-card__icon { display: flex; align-items: center; justify-content: center; width: 40px; height: 40px; border-radius: 12px; background: #FFF1D6; color: #7A4B00; }\n#clientInterfaceModulePopup .ci-qc__custom .ci-modal-picker-card__text { display: flex; flex-direction: column; gap: 2px; min-width: 0; }\n#clientInterfaceModulePopup .ci-qc__custom .ci-modal-picker-card__title { font-size: 15px; font-weight: 800; color: #17201C; }\n#clientInterfaceModulePopup .ci-qc__custom .ci-modal-picker-card__desc { font-size: 12.5px; color: #4A5650; line-height: 1.3; }\n#clientInterfaceModulePopup .ci-qc__custom .ci-modal-picker-card__chev { color: #8A8F8B; display: flex; }\n@media (max-width: 340px) { #clientInterfaceModulePopup .ci-qc__kinds { grid-template-columns: minmax(0, 1fr); } #clientInterfaceModulePopup .ci-qc button.ci-qc__kind { min-height: 0 !important; } }\n\n#clientInterfaceModulePopup .ci-qc__tpls { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 8px; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__tpl { display: flex !important; align-items: center; gap: 10px; width: 100% !important; height: 56px !important; min-height: 56px !important; margin: 0 !important; padding: 0 12px !important; border-radius: 14px !important; border: 1.5px solid #E4E2DC !important; background: #FFFFFF !important; background-image: none !important; color: #17201C !important; box-shadow: none !important; text-align: left !important; text-transform: none !important; letter-spacing: 0 !important; transform: none !important; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__tpl b { font-size: 14.5px; font-weight: 800; line-height: 1.2; }\n#clientInterfaceModulePopup .ci-qc__tplicon { flex: none; display: flex; align-items: center; justify-content: center; width: 34px; height: 34px; border-radius: 10px; background: #F5F4F0; font-size: 19px; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__tpl.is-open { border-color: #17201C !important; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__tpl.is-on { border-color: #1E7A4C !important; background: #F1F9F4 !important; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__tpl.is-on .ci-qc__tplicon { background: #DCEFE3; }\n#clientInterfaceModulePopup .ci-qc__variants { grid-column: 1 / -1; display: grid; gap: 6px; padding: 10px; border-radius: 14px; background: #FFFFFF; border: 1.5px solid #17201C; }\n#clientInterfaceModulePopup .ci-qc__variants[hidden] { display: none !important; }\n#clientInterfaceModulePopup .ci-qc__varhead { font-size: 12.5px; font-weight: 800; color: #4A5650; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__variant { display: flex !important; align-items: center; gap: 10px; width: 100% !important; height: auto !important; min-height: 46px !important; margin: 0 !important; padding: 8px 10px !important; border-radius: 12px !important; border: 1px solid #E4E2DC !important; background: #FAFAF7 !important; background-image: none !important; color: #17201C !important; box-shadow: none !important; text-align: left !important; font-size: 14px !important; font-weight: 600 !important; line-height: 1.3 !important; white-space: normal !important; text-transform: none !important; letter-spacing: 0 !important; transform: none !important; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__variant i { flex: none; width: 18px; height: 18px; border-radius: 50%; border: 2px solid #B8B4AA; background: #FFF; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__variant.is-on { border-color: #1E7A4C !important; background: #F1F9F4 !important; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__variant.is-on i { border: 5px solid #1E7A4C; }\n#clientInterfaceModulePopup .ci-qc__own { display: grid; gap: 6px; margin-top: 4px; }\n#clientInterfaceModulePopup .ci-qc__own span { font-size: 13px; font-weight: 700; color: #4A5650; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__go { height: auto !important; min-height: 50px !important; padding: 10px 14px !important; white-space: normal !important; line-height: 1.2 !important; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__link { height: auto !important; min-height: 36px !important; white-space: normal !important; }\n#clientInterfaceModulePopup .ci-qc__notary span { display: block; line-height: 1.4; }\n\n#clientInterfaceModulePopup button.ci-qc__redeem { display: grid !important; grid-template-columns: 40px minmax(0,1fr); grid-template-rows: auto auto; column-gap: 10px; align-items: center; width: 100% !important; height: auto !important; min-height: 60px !important; margin: 0 0 10px !important; padding: 10px 14px !important; border-radius: 16px !important; border: 0 !important; background: #17201C !important; background-image: none !important; color: #FFFFFF !important; text-align: left !important; box-shadow: none !important; text-transform: none !important; letter-spacing: 0 !important; transform: none !important; flex: none !important; }\n#clientInterfaceModulePopup button.ci-qc__redeem span { grid-row: 1 / 3; font-size: 26px; }\n#clientInterfaceModulePopup button.ci-qc__redeem b { font-size: 16px; font-weight: 800; }\n#clientInterfaceModulePopup button.ci-qc__redeem small { font-size: 12.5px; opacity: .75; }\n\n#clientInterfaceModulePopup .ci-qc__preview { display: grid; grid-template-columns: 96px minmax(0,1fr); gap: 12px; align-items: center; padding: 10px; border-radius: 16px; background: #FFFFFF; border: 1.5px solid #CFE6D7; }\n#clientInterfaceModulePopup .ci-qc__preview[hidden] { display: none !important; }\n#clientInterfaceModulePopup .ci-qc__preview img { width: 96px; height: 64px; object-fit: cover; border-radius: 10px; display: block; }\n#clientInterfaceModulePopup .ci-qc__preview div { display: grid; gap: 2px; min-width: 0; }\n#clientInterfaceModulePopup .ci-qc__preview span { font-size: 11px; font-weight: 800; letter-spacing: .06em; text-transform: uppercase; color: #1E7A4C; }\n#clientInterfaceModulePopup .ci-qc__preview b { font-size: 14px; font-weight: 800; color: #17201C; line-height: 1.25; }\n#clientInterfaceModulePopup .ci-qc__preview small { font-size: 12px; color: #4A5650; }\n\n/* v78.7: 3 tipuri \u2014 list\u0103 */\n#clientInterfaceModulePopup .ci-qc__kinds { grid-template-columns: minmax(0, 1fr) !important; gap: 8px; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__kind { display: grid !important; grid-template-columns: 48px minmax(0, 1fr); grid-template-rows: auto auto auto; column-gap: 12px; row-gap: 2px; align-items: center; min-height: 0 !important; padding: 12px 40px 12px 12px !important; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__kind .ci-qc__kindicon { grid-row: 1 / 4; margin: 0; width: 48px; height: 48px; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__kind .ci-qc__badge { margin-top: 2px; justify-self: start; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__kind.is-on::after { top: 50%; transform: translateY(-50%); }\n#clientInterfaceModulePopup .ci-qc__badge--scratch { background: #FFF1D6; color: #7A4B00; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__kind--scratch.is-on { border-color: #B45309 !important; background: #FFF8EC !important; box-shadow: 0 6px 18px rgba(180,83,9,.16) !important; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__kind--scratch.is-on .ci-qc__kindicon { background: #B45309; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__kind--scratch.is-on::after { background: #B45309; }\n#clientInterfaceModulePopup .ci-qc__s[hidden] { display: none !important; }\n#clientInterfaceModulePopup .ci-qc__s { display: flex; flex-direction: column; gap: 8px; padding: 12px; border-radius: 16px; background: #FAFAF7; border: 1px solid #EEEDE8; min-width: 0; }\n#clientInterfaceModulePopup .ci-qc__s > * { min-width: 0; max-width: 100%; box-sizing: border-box; }\n#clientInterfaceModulePopup .ci-qc__notary--ok { background: #F1F9F4; border-color: #CFE6D7; color: #145A37; }\n#clientInterfaceModulePopup .ci-qc__srows { display: grid; gap: 6px; }\n#clientInterfaceModulePopup .ci-qc__srow { display: grid; grid-template-columns: minmax(0, 1fr) 64px 52px 36px; gap: 6px; align-items: center; }\n#clientInterfaceModulePopup .ci-qc__srow--head span { font-size: 11px; font-weight: 800; letter-spacing: .06em; text-transform: uppercase; color: #6B716D; }\n#clientInterfaceModulePopup .ci-qc__srow input.ci-qc__qty { padding: 0 8px !important; text-align: center; }\n#clientInterfaceModulePopup .ci-qc__ssum { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 6px; }\n#clientInterfaceModulePopup .ci-qc__ssum div { display: grid; justify-items: center; padding: 8px 4px; border-radius: 12px; background: #FFFFFF; border: 1px solid #EEEDE8; }\n#clientInterfaceModulePopup .ci-qc__ssum div.is-win { background: #FFF3D6; border-color: #F3D9A4; }\n#clientInterfaceModulePopup .ci-qc__ssum b { font-size: 20px; font-weight: 900; color: #17201C; }\n#clientInterfaceModulePopup .ci-qc__ssum span { font-size: 11.5px; color: #4A5650; }\n#clientInterfaceModulePopup .ci-qc__ssum p { grid-column: 1 / -1; margin: 0; font-size: 12.5px; color: #4A5650; text-align: center; }\n#clientInterfaceModulePopup .ci-qc__s .ci-qc__step i { background: #B45309; }\n#clientInterfaceModulePopup .ci-qc__s button.ci-qc__go { background: #B45309 !important; box-shadow: 0 8px 20px rgba(180,83,9,.25) !important; }\n\n/* v79.0 \u2014 ferestrele Campanie instant / R\u0103zuie\u0219te, totul pe un ecran */\n#clientInterfaceModulePopup .ci-camp-ov { position: fixed; inset: 0; z-index: 10050; display: none; align-items: flex-end; justify-content: center; padding: 8px; box-sizing: border-box; background: rgba(15,20,18,.55); }\n#clientInterfaceModulePopup .ci-camp-ov.is-open { display: flex; }\n@media (min-width: 560px) { #clientInterfaceModulePopup .ci-camp-ov { align-items: center; } }\n#clientInterfaceModulePopup .ci-camp-sheet { width: 100%; max-width: 440px; max-height: calc(100dvh - 16px); overflow-y: auto; margin: 0 !important; padding: 12px 14px 14px !important; border-radius: 24px !important; gap: 8px !important; box-shadow: 0 20px 50px rgba(0,0,0,.3); }\n#clientInterfaceModulePopup .ci-camp-sheet__head { display: flex; align-items: center; justify-content: space-between; gap: 10px; }\n#clientInterfaceModulePopup .ci-camp-sheet__title { font-family: 'Outfit', sans-serif; font-size: 18px; font-weight: 800; color: #17201C; }\n#clientInterfaceModulePopup .ci-camp-sheet button.ci-camp-sheet__x { width: 38px !important; height: 38px !important; min-height: 38px !important; margin: 0 !important; padding: 0 !important; border-radius: 12px !important; border: 0 !important; background: #F0EEE8 !important; background-image: none !important; color: #17201C !important; font-size: 22px !important; box-shadow: none !important; }\n#clientInterfaceModulePopup .ci-camp-sheet__body > div { padding: 0 !important; border: 0 !important; background: transparent !important; gap: 8px !important; }\n#clientInterfaceModulePopup .ci-qc__mini { font-size: 11.5px; font-weight: 800; letter-spacing: .07em; text-transform: uppercase; color: #4A5650; }\n#clientInterfaceModulePopup .ci-camp-sheet .ci-qc__tpls { grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 6px; }\n#clientInterfaceModulePopup .ci-camp-sheet button.ci-qc__tpl { flex-direction: column; justify-content: center; gap: 2px !important; height: 62px !important; min-height: 62px !important; padding: 4px !important; text-align: center !important; }\n#clientInterfaceModulePopup .ci-camp-sheet .ci-qc__tplicon { width: 28px; height: 28px; font-size: 17px; background: transparent; }\n#clientInterfaceModulePopup .ci-camp-sheet button.ci-qc__tpl b { font-size: 12.5px; line-height: 1.1; }\n#clientInterfaceModulePopup .ci-camp-sheet .ci-qc__variants { gap: 4px; padding: 6px; border-width: 1.5px; }\n#clientInterfaceModulePopup .ci-camp-sheet button.ci-qc__variant { min-height: 36px !important; padding: 6px 8px !important; font-size: 13px !important; }\n#clientInterfaceModulePopup .ci-camp-sheet button.ci-qc__variant i { width: 16px; height: 16px; }\n#clientInterfaceModulePopup .ci-qc__pair { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; }\n#clientInterfaceModulePopup .ci-qc__field { display: grid; gap: 3px; margin: 0 !important; font-size: 11.5px !important; font-weight: 800 !important; letter-spacing: .05em; text-transform: uppercase; color: #4A5650 !important; }\n#clientInterfaceModulePopup .ci-qc select.ci-qc__sel { width: 100% !important; height: 42px !important; min-height: 42px !important; margin: 0 !important; padding: 0 10px !important; border-radius: 12px !important; border: 1px solid #E4E2DC !important; background: #F5F4F0 !important; font-size: 15px !important; font-weight: 700 !important; color: #17201C !important; text-transform: none !important; letter-spacing: 0 !important; }\n#clientInterfaceModulePopup .ci-qc__toggle { display: grid !important; grid-template-columns: minmax(0,1fr) 48px; align-items: center; gap: 10px; margin: 0 !important; padding: 8px 12px; border-radius: 14px; background: #FFFFFF; border: 1px solid #E4E2DC; cursor: pointer; text-transform: none !important; letter-spacing: 0 !important; position: relative; }\n#clientInterfaceModulePopup .ci-qc__toggletext { display: grid; gap: 1px; }\n#clientInterfaceModulePopup .ci-qc__toggletext b { font-size: 14px; color: #17201C; }\n#clientInterfaceModulePopup .ci-qc__toggletext small { font-size: 12px; color: #4A5650; font-weight: 500; }\n#clientInterfaceModulePopup .ci-qc__toggle input { position: absolute; opacity: 0; width: 1px; height: 1px; }\n#clientInterfaceModulePopup .ci-qc__toggle i { width: 48px; height: 28px; border-radius: 999px; background: #D5D2CA; position: relative; transition: background .15s; }\n#clientInterfaceModulePopup .ci-qc__toggle i::after { content: ''; position: absolute; top: 3px; left: 3px; width: 22px; height: 22px; border-radius: 50%; background: #FFF; box-shadow: 0 1px 3px rgba(0,0,0,.25); transition: transform .15s; }\n#clientInterfaceModulePopup .ci-qc__toggle input:checked + i { background: #1E7A4C; }\n#clientInterfaceModulePopup .ci-qc__toggle input:checked + i::after { transform: translateX(20px); }\n#clientInterfaceModulePopup .ci-qc__actions { display: grid; grid-template-columns: 1fr 1.6fr; gap: 8px; align-items: center; }\n#clientInterfaceModulePopup .ci-qc__actions button.ci-qc__go { margin: 0 !important; }\n#clientInterfaceModulePopup .ci-qc__actions button.ci-qc__link { min-height: 48px !important; border: 1px solid #E4E2DC !important; background: #FFF !important; text-decoration: none !important; color: #17201C !important; border-radius: 14px !important; }\n#clientInterfaceModulePopup .ci-qc p.ci-qc__ssum { display: block; margin: 0; padding: 8px 10px; border-radius: 12px; background: #FFF3D6; border: 0; font-size: 13px; font-weight: 700; color: #5C3D00; text-align: center; }\n#clientInterfaceModulePopup .ci-qc p.ci-qc__ssum.is-bad { background: #FDECEA; color: #9B2C1F; }\n#clientInterfaceModulePopup .ci-camp-sheet .ci-qc__srow input.ci-qc__in, #clientInterfaceModulePopup .ci-camp-sheet .ci-qc__srow input.ci-qc__qty { height: 38px !important; min-height: 38px !important; }\n#clientInterfaceModulePopup .ci-camp-sheet button.ci-qc__add { height: 34px !important; min-height: 34px !important; }\n#clientInterfaceModulePopup .ci-camp-sheet input.ci-qc__in { height: 40px !important; min-height: 40px !important; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__kind .ci-qc__kindgo { position: absolute; right: 14px; top: 50%; transform: translateY(-50%); font-size: 26px; font-weight: 700; color: #8A8F8B; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__kind--guaranteed.is-on::after, #clientInterfaceModulePopup .ci-qc button.ci-qc__kind--scratch.is-on::after { display: none; }\n\n#clientInterfaceModulePopup .ci-camp-sheet.ci-camp-sheet--big { max-width: 520px; height: calc(100dvh - 16px); align-content: start; }\n#clientInterfaceModulePopup .ci-camp-sheet--big .ci-camp-sheet__body { display: grid; gap: 8px; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__kind.is-on::after { display: none; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__kind.is-on .ci-qc__kindgo { color: #17201C; }\n\n#clientInterfaceModulePopup .ci-qc__adv { display: grid; gap: 6px; }\n#clientInterfaceModulePopup .ci-qc__people { display: grid; gap: 6px; padding: 8px; border-radius: 12px; background: #F5F4F0; }\n#clientInterfaceModulePopup .ci-qc__people[hidden] { display: none !important; }\n#clientInterfaceModulePopup .ci-qc__person { display: inline-flex; align-items: center; gap: 4px; padding: 4px 4px 4px 10px; border-radius: 999px; background: #FFFFFF; border: 1px solid #E4E2DC; font-size: 13.5px; font-weight: 700; color: #17201C; }\n#clientInterfaceModulePopup .ci-qc__person button { width: 24px !important; height: 24px !important; min-height: 24px !important; margin: 0 !important; padding: 0 !important; border-radius: 50% !important; border: 0 !important; background: #F1E4E2 !important; background-image: none !important; color: #B42318 !important; font-size: 15px !important; line-height: 1 !important; box-shadow: none !important; }\n#clientInterfaceModulePopup .ci-qc__peopleempty { font-size: 12.5px; color: #9B2C1F; }\n#clientInterfaceModulePopup .ci-qc__addrow { display: grid; grid-template-columns: minmax(0,1fr) auto; gap: 6px; }\n#clientInterfaceModulePopup .ci-qc__addrow input.ci-qc__in { height: 38px !important; min-height: 38px !important; background: #FFFFFF !important; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__addp { width: auto !important; height: 38px !important; min-height: 38px !important; margin: 0 !important; padding: 0 12px !important; border-radius: 12px !important; border: 0 !important; background: #17201C !important; background-image: none !important; color: #FFF !important; font-size: 13.5px !important; font-weight: 800 !important; box-shadow: none !important; }\n\n#clientInterfaceModulePopup .ci-qc__cap { display: grid !important; grid-template-columns: minmax(0,1fr) 84px auto; align-items: center; gap: 8px; margin: 0 !important; padding: 6px 10px; border-radius: 12px; background: #E6F2EA; text-transform: none !important; letter-spacing: 0 !important; }\n#clientInterfaceModulePopup .ci-qc__cap[hidden] { display: none !important; }\n#clientInterfaceModulePopup .ci-qc__cap span { font-size: 13px; font-weight: 700; color: #145A37; }\n#clientInterfaceModulePopup .ci-qc__cap b { font-size: 13px; color: #145A37; }\n#clientInterfaceModulePopup .ci-qc__cap input.ci-qc__qty { height: 36px !important; min-height: 36px !important; background: #FFFFFF !important; padding: 0 8px !important; text-align: center; }\n\n#clientInterfaceModulePopup .ci-camp-sheet { gap: 6px !important; }\n#clientInterfaceModulePopup .ci-camp-sheet__body > div { gap: 6px !important; }\n#clientInterfaceModulePopup .ci-camp-sheet button.ci-qc__tpl { height: 54px !important; min-height: 54px !important; }\n#clientInterfaceModulePopup .ci-camp-sheet .ci-qc__tplicon { width: 24px; height: 24px; }\n#clientInterfaceModulePopup .ci-camp-sheet .ci-qc__toggle { padding: 6px 12px; }\n#clientInterfaceModulePopup .ci-camp-sheet button.ci-qc__go { min-height: 46px !important; }\n\n#clientInterfaceModulePopup .ci-qc__pair.ci-qc__pair--3 { grid-template-columns: 1fr 1fr 1fr; gap: 6px; }\n#clientInterfaceModulePopup .ci-qc__pair--3 .ci-qc__field { font-size: 10.5px !important; letter-spacing: .03em; white-space: nowrap; }\n#clientInterfaceModulePopup .ci-qc__pair--3 select.ci-qc__sel { padding: 0 6px !important; font-size: 14px !important; }\n";

/* Stilurile panoului sunt injectate din JS — merg și dacă foaia CSS din pagină e din versiunea veche. */
const QC_CSS = "/* Campanie rapid\u0103 (v72.8) \u2014 totul pe un ecran */\n#clientInterfaceModulePopup .ci-qc { display: grid; gap: 8px; padding: 14px; margin: 0 0 12px; border-radius: 20px; background: #FFFFFF; border: 1px solid #E4E2DC; }\n#clientInterfaceModulePopup .ci-qc--active { background: #E6F2EA; border-color: #CFE6D7; }\n#clientInterfaceModulePopup .ci-qc__title { font-family: 'Outfit', sans-serif; font-size: 18px; font-weight: 800; color: #17201C; }\n#clientInterfaceModulePopup .ci-qc__hint { font-size: 13.5px; color: #4A5650; }\n#clientInterfaceModulePopup .ci-qc__label { margin-top: 4px; font-size: 11.5px; font-weight: 800; letter-spacing: .08em; text-transform: uppercase; color: #4A5650; }\n#clientInterfaceModulePopup .ci-qc__chips { display: flex; flex-wrap: wrap; gap: 6px; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__chip { width: auto !important; min-height: 38px !important; height: 38px !important; margin: 0 !important; padding: 0 12px !important; border-radius: 999px !important; border: 1px solid #E4E2DC !important; background: #F5F4F0 !important; background-image: none !important; color: #17201C !important; font-size: 13.5px !important; font-weight: 700 !important; box-shadow: none !important; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__chip.is-on { background: #17201C !important; border-color: #17201C !important; color: #F5F4F0 !important; }\n#clientInterfaceModulePopup .ci-qc__prizes { display: grid; gap: 6px; }\n#clientInterfaceModulePopup .ci-qc__row { display: grid; grid-template-columns: minmax(0, 1fr) 92px 36px; gap: 6px; align-items: center; }\n#clientInterfaceModulePopup .ci-qc input.ci-qc__in, #clientInterfaceModulePopup .ci-qc input.ci-qc__qty { width: 100% !important; height: 44px !important; min-height: 44px !important; margin: 0 !important; padding: 0 12px !important; border-radius: 12px !important; border: 1px solid #E4E2DC !important; background: #F5F4F0 !important; font-size: 15px !important; color: #17201C !important; }\n#clientInterfaceModulePopup .ci-qc__qtywrap { position: relative; display: block; margin: 0; }\n#clientInterfaceModulePopup .ci-qc input.ci-qc__qty { padding-right: 34px !important; text-align: right; }\n#clientInterfaceModulePopup .ci-qc__qtywrap span { position: absolute; right: 10px; top: 50%; transform: translateY(-50%); font-size: 12px; color: #4A5650; pointer-events: none; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__del { width: 36px !important; height: 36px !important; min-height: 36px !important; margin: 0 !important; padding: 0 !important; border-radius: 10px !important; border: 1px solid #F1C9C9 !important; background: #FFF !important; background-image: none !important; color: #B42318 !important; font-size: 20px !important; line-height: 1 !important; box-shadow: none !important; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__add { width: 100% !important; height: 40px !important; min-height: 40px !important; margin: 0 !important; border-radius: 12px !important; border: 1px dashed #B8B4AA !important; background: transparent !important; background-image: none !important; color: #17201C !important; font-weight: 700 !important; font-size: 14px !important; box-shadow: none !important; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__go { width: 100% !important; height: 52px !important; min-height: 52px !important; margin: 6px 0 0 !important; border-radius: 14px !important; border: 0 !important; background: #1E7A4C !important; background-image: none !important; color: #FFF !important; font-weight: 800 !important; font-size: 16px !important; box-shadow: 0 8px 20px rgba(30,122,76,.22) !important; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__link, #clientInterfaceModulePopup .ci-qc button.ci-qc__ghost { width: 100% !important; height: 40px !important; min-height: 40px !important; margin: 0 !important; border-radius: 12px !important; border: 1px solid #E4E2DC !important; background: #FFF !important; background-image: none !important; color: #17201C !important; font-weight: 700 !important; font-size: 14px !important; box-shadow: none !important; }\n#clientInterfaceModulePopup .ci-qc__status { margin: 0; font-size: 13.5px; color: #8A3B10; }\n#clientInterfaceModulePopup .ci-qc__more { font-size: 12.5px; color: #4A5650; text-align: center; }\n/* compact: totul pe un ecran */\n#clientInterfaceModulePopup .ci-qc { gap: 6px; padding: 12px; }\n#clientInterfaceModulePopup .ci-qc__chips { flex-wrap: nowrap; overflow-x: auto; scrollbar-width: none; -webkit-overflow-scrolling: touch; }\n#clientInterfaceModulePopup .ci-qc__chips::-webkit-scrollbar { display: none; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__chip { flex: none; height: 34px !important; min-height: 34px !important; padding: 0 11px !important; font-size: 13px !important; }\n#clientInterfaceModulePopup .ci-qc__label { margin-top: 2px; }\n#clientInterfaceModulePopup .ci-qc input.ci-qc__in, #clientInterfaceModulePopup .ci-qc input.ci-qc__qty { height: 40px !important; min-height: 40px !important; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__add { height: 36px !important; min-height: 36px !important; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__go { height: 48px !important; min-height: 48px !important; margin-top: 4px !important; }\n#clientInterfaceModulePopup .ci-qc button.ci-qc__link { height: 36px !important; min-height: 36px !important; border: 0 !important; background: transparent !important; color: #4A5650 !important; text-decoration: underline; }";
function ensureQuickCampaignStyles() {
  if (document.getElementById('sjQcStyles')) return;
  const st = document.createElement('style');
  st.id = 'sjQcStyles';
  st.textContent = QC_CSS + QC_CSS2 + '\n#clientInterfaceModulePopup #clientInterfaceModulePopupPicker { overflow-y: auto !important; overflow-x: hidden !important; min-height: 0; -webkit-overflow-scrolling: touch; overscroll-behavior: contain; }';
  document.head.appendChild(st);
}

/** Panou „Campanie rapidă”: premii + durată + jocuri (+ PIN) pe un singur ecran, un buton. */
/** Poza voucherului: din campania gata făcută aleasă; altfel cea pusă de comerciant; altfel cadou generic. */
function instantImageFor(reward) {
  const t = INSTANT_TEMPLATES.find((x) => x.variants.includes(reward));
  if (t) return t.image;
  const cur = (getCurrentSettings()?.prizes || [])[0];
  if (cur && cur.image && String(cur.message || '').trim() === reward) return cur.image;
  return '/img/rewards/cadou.svg';
}

/** Poză automată pentru premiile de răzuit, după cuvinte cheie. */
function scratchImageFor(text) {
  const t = String(text || '').toLowerCase();
  if (/cafea|espresso|cappuccino/.test(t)) return '/img/rewards/cafea.svg';
  if (/reducere|%/.test(t)) return '/img/rewards/reducere.svg';
  if (/voucher|lei|card cadou/.test(t)) return '/img/rewards/voucher.svg';
  if (/desert|tort|prăjitur|inghetat|înghețat/.test(t)) return '/img/rewards/desert.svg';
  if (/suc|limonad|bere|vin|cocktail|băutur|bautur/.test(t)) return '/img/rewards/bautura.svg';
  return '/img/rewards/cadou.svg';
}

/** Ultima alegere din panou (rămâne la întoarcerea din personalizare). */
let lastQcKind = null;
/** Revenim din „Premii și poze” etc. → redeschidem fereastra campaniei cu extragere. */
let reopenLotterySheet = false; // 'random' | false — foaia de redeschis după o secțiune de personalizare

function buildQuickCampaignBlock(customCards) {
  const settings = getCurrentSettings();
  if (!settings) return null;
  ensureQuickCampaignStyles();

  if (settings.campaignStatus === 'active') {
    const end = settings.endDate ? `până pe ${fmtRo(settings.endDate)}` : 'fără dată de final';
    const isG = settings.campaignKind === 'guaranteed';
    const isDraw = settings.campaignKind === 'tombola';
    const activeName = isG ? CAMPAIGN_NAMES.guaranteed : settings.campaignKind === 'scratch' ? CAMPAIGN_NAMES.scratch : isDraw ? CAMPAIGN_NAMES.lottery : CAMPAIGN_NAMES.random;
    return qcEl('div', { class: 'ci-qc ci-qc--active' },
      qcEl('b', { class: 'ci-qc__title', text: `🟢 ${activeName} e activă` }),
      qcEl('span', { class: 'ci-qc__hint', text: settings.campaignKind === 'tombola' && Array.isArray(settings.drawPrizes) && settings.drawPrizes.length ? `${end} · extragerea: ${String(settings.campaignLegal?.drawDate || '').split('-').reverse().join('.')}${settings.campaignLegal?.drawTime ? `, ora ${settings.campaignLegal.drawTime}` : ''}` : `${end} · ${Number(settings.remainingTries) || 0} ${settings.campaignKind === 'scratch' ? 'bilete' : 'jocuri'} rămase din ${Number(settings.totalTries) || 0}` }),
      qcEl('button', { type: 'button', class: 'ci-qc__ghost', onclick: () => import('./mod-client-modules.js?v=83.79').then((m) => m.toggleModClientCampanii()) }, 'Oprește campania'),
      !isG && !isDraw && Array.isArray(customCards) && customCards.length
        ? qcEl('div', { class: 'ci-qc__custom' }, qcEl('div', { class: 'ci-qc__customhead' }, qcEl('b', { text: '✨ Personalizează campania' })), ...customCards)
        : null,
      isDraw ? qcEl('button', { type: 'button', class: 'ci-qc__ghost', onclick: () => import('./popups.js?v=83.79').then((m) => m.showAutoRules()) }, '📜 Regulamentul campaniei') : null,
      // organizator = firma localului: regulament nou sau act adițional oricând în timpul campaniei
      !isG && settings.campaignKind !== 'scratch' && !(isDraw && settings.campaignOrganizer === 'spressjoy')
        ? qcEl('button', { type: 'button', class: 'ci-qc__ghost', onclick: () => import('../legal/legal-notary.js?v=83.79').then((m) => m.openUpdateOwnRules()) }, '📎 Regulament nou / act adițional (PDF)')
        : null
    );
  }

  const existing = (Array.isArray(settings.prizes) ? settings.prizes : []).filter((p) => p && String(p.message || '').trim());
  // Peste 6 premii: panoul rapid nu le poate arăta pe toate → doar Setări avansate (altfel s-ar pierde premii la salvare)
  const rowsState = existing.length
    ? existing.slice(0, 6).map((p) => ({ message: String(p.message), count: Number(p.count) || 0, image: p.image || null, id: p.id || null }))
    : [{ message: '', count: 10, image: null, id: null }];
  // Pornim de la ce e deja salvat (durata și numărul de jocuri), altfel 30 de zile / 300 jocuri.
  let duration = '30';
  if (!settings.endDate && settings.startDate) duration = 'none';
  else if (settings.endDate && settings.startDate) {
    const days = Math.round((Date.parse(settings.endDate) - Date.parse(settings.startDate)) / 86400000);
    const hit = QUICK_DURATIONS.find((d) => d.days === days);
    if (hit) duration = hit.id;
    else if (settings.endDate === endOfMonthRo()) duration = 'month';
  }
  let tries = Number(settings.totalTries) > 0 ? Number(settings.totalTries) : 300;
  const hasPin = true; // PIN-ul nu mai e necesar
  // Tip campanie: premiu sigur (fără notar) sau la noroc (cu notar, OG 99/2000 art. 43)
  const canG = hasFeature(settings, 'campaignGuaranteed');
  const canL = hasFeature(settings, 'campaignLottery');
  const canS = hasFeature(settings, 'campaignScratch');
  let kind = settings.campaignKind === 'guaranteed' ? 'guaranteed' : settings.campaignKind === 'scratch' ? 'scratch' : settings.campaignKind === 'tombola' ? 'lottery' : 'guaranteed';
  if (lastQcKind && lastQcKind !== 'random') kind = lastQcKind;
  if (kind === 'guaranteed' && !canG && canL) kind = 'lottery';
  if ((kind === 'lottery' || kind === 'random') && !canL && canG) kind = 'guaranteed';
  let gReward = kind === 'guaranteed' && existing[0] ? String(existing[0].message) : '';
  // „(la o notă de maximum N lei)” se păstrează separat, ca să-l poți edita
  let gCap = '';
  const capM = gReward.match(/\s*\(la o notă de maximum (\d+) lei\)\s*$/);
  if (capM) { gCap = capM[1]; gReward = gReward.slice(0, capM.index); }

  const box = qcEl('div', { class: 'ci-qc' });
  const list = qcEl('div', { class: 'ci-qc__prizes' });

  function renderRows() {
    list.replaceChildren(
      ...rowsState.map((r, i) => {
        const name = qcEl('input', { type: 'text', class: 'ci-qc__in', placeholder: 'ex. O cafea gratuită', maxlength: '200', 'aria-label': `Premiul ${i + 1}` });
        name.value = r.message;
        name.addEventListener('input', () => { r.message = name.value; });
        const qty = qcEl('input', { type: 'number', class: 'ci-qc__qty', min: '1', max: '10000', inputmode: 'numeric', 'aria-label': 'Bucăți' });
        qty.value = r.count || '';
        qty.addEventListener('input', () => { r.count = parseInt(qty.value, 10) || 0; });
        const del = qcEl('button', { type: 'button', class: 'ci-qc__del', 'aria-label': 'Șterge premiul', onclick: () => { rowsState.splice(i, 1); if (!rowsState.length) rowsState.push({ message: '', count: 10, image: null, id: null }); renderRows(); } }, '×');
        return qcEl('div', { class: 'ci-qc__row' }, name, qtyWrap(qty), del);
      }),
      rowsState.length < 6
        ? qcEl('button', { type: 'button', class: 'ci-qc__add', onclick: () => { rowsState.push({ message: '', count: 10, image: null, id: null }); renderRows(); } }, '+ Încă un premiu')
        : null
    );
  }
  function qtyWrap(input) {
    return qcEl('label', { class: 'ci-qc__qtywrap' }, input, qcEl('span', { text: 'buc.' }));
  }

  const presetRow = qcEl('div', { class: 'ci-qc__chips' },
    QUICK_CAMPAIGN_PRESETS.map((p) => qcEl('button', { type: 'button', class: 'ci-qc__chip', onclick: () => {
      rowsState.splice(0, rowsState.length, ...p.prizes.map(([message, count]) => ({ message, count, image: null, id: null })));
      renderRows();
    } }, p.label))
  );

  function chips(items, getActive, onPick) {
    const wrap = qcEl('div', { class: 'ci-qc__chips' });
    const draw = () => wrap.replaceChildren(...items.map((it) => qcEl('button', {
      type: 'button',
      class: `ci-qc__chip${getActive() === it.value ? ' is-on' : ''}`,
      onclick: () => { onPick(it.value); draw(); }
    }, it.label)));
    draw();
    return wrap;
  }

  const durChips = chips(QUICK_DURATIONS.map((d) => ({ value: d.id, label: d.label })), () => duration, (v) => { duration = v; });
  const triesList = QUICK_TRIES.includes(tries) ? QUICK_TRIES : [tries, ...QUICK_TRIES].sort((a, b) => a - b);
  const triesChips = chips(triesList.map((n) => ({ value: n, label: String(n) })), () => tries, (v) => { tries = v; });
  const pinInput = hasPin ? null : qcEl('input', { type: 'password', class: 'ci-qc__in ci-qc__pin', inputmode: 'numeric', maxlength: '12', placeholder: 'PIN (minim 4 cifre)', autocomplete: 'new-password' });
  const status = qcEl('p', { class: 'ci-qc__status', hidden: true });
  const startBtn = qcEl('button', { type: 'button', class: 'ci-qc__go' }, 'Pornește campania');
  const saveOnly = qcEl('button', { type: 'button', class: 'ci-qc__link' }, 'Doar salvează, pornesc mai târziu');

  async function submit(start) {
    if (kind === 'guaranteed') {
      let reward = String(gReward || '').trim().slice(0, 160);
      if (!reward) { status.hidden = false; status.textContent = 'Scrie ce primește fiecare client (ex: 10% reducere la următoarea vizită).'; return; }
      if (/%/.test(reward)) {
        const cap = parseInt(gCap, 10);
        if (!(cap > 0)) { status.hidden = false; status.textContent = 'La reducerea procentuală scrie valoarea maximă a notei (ex: 200 lei).'; return; }
        reward = `${reward} (la o notă de maximum ${cap} lei)`;
      }
      const startDateG = roToday();
      const dg = QUICK_DURATIONS.find((x) => x.id === duration);
      const endDateG = duration === 'none' ? '' : duration === 'month' ? endOfMonthRo() : quickIsoDate(dg.days);
      const payloadG = {
        prizes: [{ id: existing[0]?.id || `prize_${Date.now()}_0`, message: reward, count: tries, image: instantImageFor(String(gReward || '').trim()) }],
        totalTries: tries,
        remainingTries: tries,
        startDate: startDateG,
        endDate: endDateG,
        campaignKind: 'guaranteed',
        receiptScan: bonG,
        voucherValidDays: vDays,
        buttonText: 'Ia-ți cadoul!',
        defaultPrizeMsg: 'Mulțumim! Toate cadourile au fost oferite.'
      };
      startBtn.disabled = true; saveOnly.disabled = true;
      status.hidden = false; status.textContent = start ? 'Pornesc campania…' : 'Salvez…';
      try {
        const m = await import('./mod-client-modules.js?v=83.79');
        const ok = await m.quickSaveAndStartCampaign(payloadG, { start });
        if (ok === false) { status.hidden = true; return; }
        closeCampSheet();
        if (!start) showSnackbar('Campania e salvată. O pornești când vrei.', 'success');
        status.hidden = true;
      } catch (e) {
        status.textContent = e?.message || 'Nu am putut porni campania.';
      } finally {
        startBtn.disabled = false; saveOnly.disabled = false;
      }
      return;
    }
    const prizes = rowsState
      .map((r, i) => ({ ...r, message: String(r.message || '').trim().slice(0, 200), count: Math.max(0, Math.min(10000, parseInt(r.count, 10) || 0)), i }))
      .filter((r) => r.message);
    if (!prizes.length || !prizes.some((p) => p.count > 0)) {
      status.hidden = false; status.textContent = 'Scrie cel puțin un premiu și câte bucăți ai.'; return;
    }
    let passHash = null;
    if (!hasPin) {
      const pin = String(pinInput?.value || '').trim();
      if (pin.length < 4) { status.hidden = false; status.textContent = 'Alege un PIN de minim 4 cifre — îl folosești la validarea premiilor.'; pinInput?.focus(); return; }
      const { sha256 } = await import('../utils/helpers.js?v=83.79');
      passHash = await sha256(pin);
    }
    const startDate = roToday();
    const d = QUICK_DURATIONS.find((x) => x.id === duration);
    const endDate = duration === 'none' ? '' : duration === 'month' ? endOfMonthRo() : quickIsoDate(d.days);
    const payload = {
      prizes: prizes.map((p) => ({ id: p.id || `prize_${Date.now()}_${p.i}`, message: p.message, count: p.count, image: p.image || null })),
      totalTries: tries,
      remainingTries: tries,
      startDate,
      endDate,
      campaignKind: settings.campaignKind === 'tombola' ? 'tombola' : 'instant'
    };
    if (passHash) payload.adminPassHash = passHash;
    startBtn.disabled = true; saveOnly.disabled = true;
    status.hidden = false; status.textContent = start ? 'Pornesc campania…' : 'Salvez…';
    try {
      const m = await import('./mod-client-modules.js?v=83.79');
      const ok = await m.quickSaveAndStartCampaign(payload, { start });
      if (ok === false) { status.hidden = true; return; }
      if (!start) {
        showSnackbar('Campania e salvată. O pornești când vrei.', 'success');
        showCampaignPicker();
      }
      status.hidden = true;
    } catch (e) {
      status.textContent = e?.message || 'Nu am putut porni campania.';
    } finally {
      startBtn.disabled = false; saveOnly.disabled = false;
    }
  }
  startBtn.addEventListener('click', () => submit(true));
  saveOnly.addEventListener('click', () => submit(false));

  renderRows();
  const otherActive = settings.loyaltySettings?.active === true
    ? 'Fidelizarea'
    : settings.eventModule?.enabled === true
      ? 'Evenimentul'
      : '';

  const stepLabel = (n, text) => qcEl('div', { class: 'ci-qc__step' }, qcEl('i', { text: String(n) }), qcEl('span', { text }));

  // Câmp compact de tip listă (în loc de rânduri de butoane — încape totul pe un ecran)
  const qcSelect = (label, options, value, onChange) => {
    const sel = qcEl('select', { class: 'ci-qc__sel', 'aria-label': label });
    options.forEach(([v, t]) => { const o = qcEl('option', { value: String(v) }, t); if (String(v) === String(value)) o.selected = true; sel.append(o); });
    sel.addEventListener('change', () => onChange(sel.value));
    return qcEl('label', { class: 'ci-qc__field' }, qcEl('span', { text: label }), sel);
  };
  const durOptions = QUICK_DURATIONS.map((d) => [d.id, d.label]);
  // cât timp poate fi folosit voucherul câștigat (de a doua zi)
  let vDays = [7, 14, 30].includes(Number(settings.voucherValidDays)) ? Number(settings.voucherValidDays) : 7;
  const VALID_OPTS = [[7, '7 zile'], [14, '14 zile'], [30, '30 zile']];
  const bonToggle = (get, set, textOn, textOff) => {
    const wrap = qcEl('label', { class: 'ci-qc__toggle' });
    const input = qcEl('input', { type: 'checkbox' });
    input.checked = get();
    const sub = qcEl('small');
    const draw = () => { sub.textContent = input.checked ? textOn : textOff; };
    input.addEventListener('change', () => { set(input.checked); draw(); });
    draw();
    wrap.append(qcEl('span', { class: 'ci-qc__toggletext' }, qcEl('b', { text: '🧾 Cere bon fiscal' }), sub), input, qcEl('i', { 'aria-hidden': 'true' }));
    return wrap;
  };

  // Revendicare avansată: clientul alege responsabilul (ospătarul) la revendicare
  const advancedClaimsBlock = () => {
    const wrap = qcEl('div', { class: 'ci-qc__adv' });
    const input = qcEl('input', { type: 'checkbox' });
    const sub = qcEl('small', { text: 'Clientul alege ospătarul care l-a servit' });
    const toggle = qcEl('label', { class: 'ci-qc__toggle' },
      qcEl('span', { class: 'ci-qc__toggletext' }, qcEl('b', { text: '👥 Revendicare avansată' }), sub),
      input, qcEl('i', { 'aria-hidden': 'true' }));
    const people = qcEl('div', { class: 'ci-qc__people', hidden: true });
    const list = qcEl('div', { class: 'ci-qc__chips ci-qc__chips--wrap' });
    const nameIn = qcEl('input', { type: 'text', class: 'ci-qc__in', placeholder: 'Nume responsabil (ex. Andrei)', maxlength: '60' });
    const addBtn = qcEl('button', { type: 'button', class: 'ci-qc__addp' }, '+ Adaugă');
    people.append(list, qcEl('div', { class: 'ci-qc__addrow' }, nameIn, addBtn));
    wrap.append(toggle, people);
    let ctx = null;
    const getCtx = async () => {
      if (ctx) return ctx;
      const [{ db }, { getCurrentUser }] = await Promise.all([
        import('../config/firebase.js?v=83.79'),
        import('../services/auth.js?v=83.79')
      ]);
      const u = getCurrentUser();
      if (!u) throw new Error('Nu ești logat.');
      ctx = { ref: db.collection('advancedClaims').doc(u.uid) };
      return ctx;
    };
    const ts = () => (window.firebase?.firestore?.FieldValue ? window.firebase.firestore.FieldValue.serverTimestamp() : new Date());
    const drawPeople = async () => {
      try {
        const { ref } = await getCtx();
        const snap = await ref.collection('responsibles').orderBy('createdAt', 'asc').get();
        const items = [];
        snap.forEach((d) => { const x = d.data() || {}; if (x.active !== false && String(x.name || '').trim()) items.push({ id: d.id, name: String(x.name) }); });
        list.replaceChildren(...(items.length ? items.map((it) => qcEl('span', { class: 'ci-qc__person' }, it.name, qcEl('button', {
          type: 'button', 'aria-label': `Șterge ${it.name}`,
          onclick: async () => { try { await ref.collection('responsibles').doc(it.id).delete(); drawPeople(); } catch (e) { showSnackbar(e?.message || 'Nu am putut șterge.', 'error'); } }
        }, '×'))) : [qcEl('small', { class: 'ci-qc__peopleempty', text: 'Adaugă cel puțin un nume.' })]));
      } catch (e) { logger.warn('[advancedClaimsBlock]', e); }
    };
    addBtn.addEventListener('click', async () => {
      const name = String(nameIn.value || '').trim().slice(0, 60);
      if (!name) return;
      addBtn.disabled = true;
      try {
        const { ref } = await getCtx();
        await ref.collection('responsibles').add({ name, active: true, createdAt: ts() });
        nameIn.value = '';
        drawPeople();
      } catch (e) { showSnackbar(e?.message || 'Nu am putut adăuga.', 'error'); } finally { addBtn.disabled = false; }
    });
    nameIn.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); addBtn.click(); } });
    input.addEventListener('change', async () => {
      people.hidden = !input.checked;
      try {
        const { ref } = await getCtx();
        await ref.set({ mode: input.checked ? 'advanced' : 'standard', updatedAt: ts() }, { merge: true });
        if (input.checked) drawPeople();
      } catch (e) { showSnackbar(e?.message || 'Nu am putut salva.', 'error'); }
    });
    // starea curentă
    getCtx().then(({ ref }) => ref.get()).then((snap) => {
      const on = snap.exists && snap.data()?.mode === 'advanced';
      input.checked = on;
      people.hidden = !on;
      if (on) drawPeople();
    }).catch(() => {});
    return wrap;
  };

  // --- Campanie instant (fereastră) ---
  let bonG = settings.campaignKind === 'guaranteed' && settings.receiptScan === true;
  const gWrap = qcEl('div', { class: 'ci-qc__g' });
  const gInput = qcEl('input', { type: 'text', class: 'ci-qc__in', placeholder: '…sau scrie tu ce primește clientul', maxlength: '200', 'aria-label': 'Ce primește fiecare client' });
  gInput.value = gReward;
  let openTpl = INSTANT_TEMPLATES.findIndex((t) => t.variants.includes(gReward));
  const tplGrid = qcEl('div', { class: 'ci-qc__tpls' });
  const tplVariants = qcEl('div', { class: 'ci-qc__variants' });
  const drawTpl = () => {
    tplGrid.replaceChildren(...INSTANT_TEMPLATES.map((t, i) => qcEl('button', {
      type: 'button',
      class: `ci-qc__tpl${openTpl === i ? ' is-open' : ''}${t.variants.includes(gReward) ? ' is-on' : ''}`,
      'aria-expanded': openTpl === i ? 'true' : 'false',
      onclick: () => { openTpl = openTpl === i ? -1 : i; drawTpl(); }
    }, qcEl('span', { class: 'ci-qc__tplicon', text: t.icon }), qcEl('b', { text: t.title }))));
    const t = INSTANT_TEMPLATES[openTpl];
    tplVariants.hidden = !t;
    if (t) {
      tplVariants.replaceChildren(...t.variants.map((v) => qcEl('button', {
        type: 'button', class: `ci-qc__variant${gReward === v ? ' is-on' : ''}`,
        onclick: () => { gReward = v; gInput.value = v; drawTpl(); if (typeof drawCap === 'function') drawCap(); }
      }, qcEl('i', { 'aria-hidden': 'true' }), qcEl('span', { text: v }))));
    }
  };
  const capIn = qcEl('input', { type: 'number', class: 'ci-qc__qty', min: '1', inputmode: 'numeric', placeholder: 'ex. 200', 'aria-label': 'Valoarea maximă a notei' });
  capIn.value = gCap;
  capIn.addEventListener('input', () => { gCap = capIn.value; });
  const capRow = qcEl('label', { class: 'ci-qc__cap' }, qcEl('span', { text: 'Reducerea se aplică la o notă de maximum' }), capIn, qcEl('b', { text: 'lei' }));
  const drawCap = () => { capRow.hidden = !/%/.test(String(gReward || '')); };
  gInput.addEventListener('input', () => { gReward = gInput.value; drawTpl(); drawCap(); });
  drawCap();
  drawTpl();
  startBtn.textContent = '🎁 Pornește campania';
  saveOnly.textContent = 'Doar salvează';
  gWrap.append(
    qcEl('span', { class: 'ci-qc__mini', text: 'Ce primește fiecare client' }),
    tplGrid,
    tplVariants,
    gInput,
    capRow,
    qcEl('div', { class: 'ci-qc__pair ci-qc__pair--3' },
      qcSelect('Durată', durOptions, duration, (v) => { duration = v; }),
      qcSelect('Cadouri', [...new Set([tries, ...QUICK_TRIES, 2000])].sort((x, y) => x - y).map((n) => [n, String(n)]), tries, (v) => { tries = parseInt(v, 10) || tries; }),
      qcSelect('Voucher valabil', VALID_OPTS, vDays, (v) => { vDays = parseInt(v, 10) || 7; })
    ),
    bonToggle(() => bonG, (v) => { bonG = v; }, 'Un cadou per bon — clientul scanează bonul', 'Fără bon — un cadou per persoană'),
    advancedClaimsBlock(),
    status,
    qcEl('div', { class: 'ci-qc__actions' }, saveOnly, startBtn)
  );

  // --- Campanie cu extragere (tombolă): înscriere gratuită, câștigătorii se trag la sorți la final ---
  const lWrap = qcEl('div', { class: 'ci-qc__l' });
  const lStatus = qcEl('p', { class: 'ci-qc__status', hidden: true });
  const lStart = qcEl('button', { type: 'button', class: 'ci-qc__go', onclick: async () => {
    const cur = getCurrentSettings() || {};
    if (!(cur.campaignKind === 'tombola' && Array.isArray(cur.drawPrizes) && cur.drawPrizes.length)) {
      lStatus.hidden = false; lStatus.textContent = 'Completează întâi „🏆 Premii și date” (premiile pe locuri, afișul, data extragerii).'; return;
    }
    lStart.disabled = true; lStatus.hidden = false; lStatus.textContent = 'Pregătesc pornirea…';
    try {
      const m = await import('./mod-client-modules.js?v=83.79');
      await m.quickSaveAndStartCampaign({ campaignKind: 'tombola', receiptScan: false, campaignOrganizer: organizer, buttonText: 'Înscrie-te!' }, { start: true });
      lStatus.hidden = true;
      closeCampSheet();
    } catch (e) {
      lStatus.textContent = e?.message || 'Nu am putut porni campania.';
    } finally { lStart.disabled = false; }
  } }, '🏆 Pornește campania');

  // --- Campanie aleatorie: clientul joacă și află pe loc dacă a câștigat (tot loterie publicitară → notar) ---
  const rWrap = qcEl('div', { class: 'ci-qc__l ci-qc__r' });
  const custom = qcEl('div', { class: 'ci-qc__custom' }, ...(Array.isArray(customCards) ? customCards : []));
  const rStatus = qcEl('p', { class: 'ci-qc__status', hidden: true });
  const rStart = qcEl('button', { type: 'button', class: 'ci-qc__go', onclick: async () => {
    const cur = getCurrentSettings() || {};
    if (!hasRealPrizes(cur) || (cur.campaignKind === 'tombola' && Array.isArray(cur.prizes) && cur.prizes.length === 1 && Number(cur.prizes[0]?.count) >= 10000)) {
      rStatus.hidden = false; rStatus.textContent = 'Adaugă mai întâi premiile, în „Premii și poze”.'; return;
    }
    rStart.disabled = true; rStatus.hidden = false; rStatus.textContent = 'Pregătesc pornirea…';
    try {
      const m = await import('./mod-client-modules.js?v=83.79');
      await m.quickSaveAndStartCampaign({ campaignKind: 'instant', receiptScan: false, campaignOrganizer: 'merchant' }, { start: true });
      rStatus.hidden = true;
      closeCampSheet();
    } catch (e) {
      rStatus.textContent = e?.message || 'Nu am putut porni campania.';
    } finally { rStart.disabled = false; }
  } }, '🍀 Pornește campania');
  rWrap.append(
    qcEl('div', { class: 'ci-qc__notary' },
      qcEl('b', { text: '⚖️ Trebuie autentificată la notar înainte de pornire' }),
      qcEl('span', { text: 'Clientul joacă și află pe loc dacă a câștigat. Organizatorul este localul; regulamentul se generează din setări.' })
    ),
    custom,
    rStatus,
    rStart
  );
  // Cine organizează (și e operatorul datelor): localul sau SpressJoy SRL — schimbă regulamentul și informarea GDPR
  let organizer = settings.campaignOrganizer === 'spressjoy' ? 'spressjoy' : 'merchant';
  const orgBox = qcEl('div', { class: 'ci-qc__variants ci-qc__org' });
  const orgOpts = [
    ['merchant', `🏪 ${String(settings.companyName || 'Localul meu').slice(0, 40)}`, 'Localul organizează și e operatorul datelor'],
    ['spressjoy', '🟢 SpressJoy SRL', 'SpressJoy organizează, localul e partener']
  ];
  const drawOrg = () => {
    orgBox.replaceChildren(qcEl('div', { class: 'ci-qc__varhead', text: 'Cine organizează campania (apare în regulament)' }),
      ...orgOpts.map(([v, t, d]) => {
        const b = qcEl('button', { type: 'button', class: `ci-qc__variant${organizer === v ? ' is-on' : ''}` }, qcEl('i'), qcEl('span', {}, qcEl('b', { text: t }), qcEl('small', { text: ` — ${d}` })));
        b.addEventListener('click', () => {
          organizer = v;
          const cur = getCurrentSettings();
          if (cur) cur.campaignOrganizer = v;
          drawOrg();
          drawLegal();
        });
        return b;
      }));
  };
  // Documente juridice (varianta A — SpressJoy organizator): date, regulament, GDPR, din aceeași sursă
  const legalSlot = qcEl('div', { class: 'ci-qc__legalslot' });
  const drawLegal = () => {
    legalSlot.replaceChildren();
    import('../legal/legal-admin.js?v=83.79').then((m) => {
      const cur = { ...(getCurrentSettings() || settings), campaignOrganizer: organizer, campaignKind: 'tombola' };
      legalSlot.replaceChildren(m.legalCard(cur, qcEl));
    }).catch(() => {});
  };
  drawOrg();
  drawLegal();
  lWrap.append(
    qcEl('div', { class: 'ci-qc__notary' },
      qcEl('b', { text: '⚖️ Trebuie autentificată la notar înainte de pornire' }),
      qcEl('span', { text: 'Clienții se înscriu gratuit; la data stabilită aplicația trage la sorți câștigătorii și rezervele.' })
    ),
    orgBox,
    legalSlot,
    lStatus,
    lStart
  );

  // --- Răzuiește și câștigă (fereastră) ---
  let bonS = settings.campaignKind === 'scratch' ? settings.receiptScan !== false : true;
  const sWrap = qcEl('div', { class: 'ci-qc__s' });
  const SCRATCH_EXAMPLE = [['Cină pentru 2 persoane', 200, 1], ['Abonament copil', 100, 2], ['Voucher de 50 lei', 50, 5]];
  const sRows = settings.campaignKind === 'scratch' && existing.length
    ? existing.map((p) => ({ message: String(p.message), value: Number(p.value) || '', count: Number(p.count) || 1, image: p.image || null }))
    : SCRATCH_EXAMPLE.map(([message, value, count]) => ({ message, value, count, image: null }));
  let sTickets = settings.campaignKind === 'scratch' && Number(settings.totalTries) > 0 ? Number(settings.totalTries) : 500;
  const sList = qcEl('div', { class: 'ci-qc__srows' });
  const sSummary = qcEl('p', { class: 'ci-qc__ssum' });
  const drawSummary = () => {
    const wins = sRows.reduce((acc, r) => acc + (String(r.message || '').trim() ? (parseInt(r.count, 10) || 0) : 0), 0);
    const lose = Math.max(0, sTickets - wins);
    sSummary.classList.toggle('is-bad', wins > sTickets);
    sSummary.textContent = wins > sTickets
      ? `⚠️ ${wins} premii, dar doar ${sTickets} bilete`
      : `🏆 ${wins} câștigătoare · 🙂 ${lose} „Ne pare rău” · șansă 1 din ${wins ? Math.round(sTickets / wins) : '—'}`;
  };
  const drawSRows = () => {
    sList.replaceChildren(
      qcEl('div', { class: 'ci-qc__srow ci-qc__srow--head' }, qcEl('span', { text: 'Premiu' }), qcEl('span', { text: 'Lei' }), qcEl('span', { text: 'Buc.' }), qcEl('span')),
      ...sRows.map((r, i) => {
        const name = qcEl('input', { type: 'text', class: 'ci-qc__in', placeholder: 'ex. Cină pentru 2', maxlength: '200', 'aria-label': `Premiul ${i + 1}` });
        name.value = r.message;
        name.addEventListener('input', () => { r.message = name.value; drawSummary(); });
        const val = qcEl('input', { type: 'number', class: 'ci-qc__qty', min: '0', inputmode: 'decimal', placeholder: 'lei', 'aria-label': 'Valoare în lei' });
        val.value = r.value || '';
        val.addEventListener('input', () => { r.value = val.value; });
        const qty = qcEl('input', { type: 'number', class: 'ci-qc__qty', min: '1', inputmode: 'numeric', 'aria-label': 'Bucăți' });
        qty.value = r.count || '';
        qty.addEventListener('input', () => { r.count = parseInt(qty.value, 10) || 0; drawSummary(); });
        const del = qcEl('button', { type: 'button', class: 'ci-qc__del', 'aria-label': 'Șterge premiul', onclick: () => { sRows.splice(i, 1); if (!sRows.length) sRows.push({ message: '', value: '', count: 1, image: null }); drawSRows(); } }, '×');
        return qcEl('div', { class: 'ci-qc__srow' }, name, val, qty, del);
      }),
      sRows.length < 6 ? qcEl('button', { type: 'button', class: 'ci-qc__add', onclick: () => { sRows.push({ message: '', value: '', count: 1, image: null }); drawSRows(); } }, '+ Încă un premiu') : null
    );
    drawSummary();
  };
  drawSRows();
  const sStatus = qcEl('p', { class: 'ci-qc__status', hidden: true });
  const sStart = qcEl('button', { type: 'button', class: 'ci-qc__go', onclick: async () => {
    const prizes = sRows
      .map((r) => ({ message: String(r.message || '').trim().slice(0, 200), value: Number(r.value) || null, count: Math.max(0, parseInt(r.count, 10) || 0), image: r.image }))
      .filter((r) => r.message && r.count > 0);
    const wins = prizes.reduce((acc, p) => acc + p.count, 0);
    if (!prizes.length) { sStatus.hidden = false; sStatus.textContent = 'Pune cel puțin un premiu.'; return; }
    if (wins > sTickets) { sStatus.hidden = false; sStatus.textContent = 'Ai mai multe premii decât bilete. Mărește numărul de bilete.'; return; }
    const d = QUICK_DURATIONS.find((x) => x.id === duration);
    const payload = {
      prizes: prizes.map((p, i) => ({ id: `prize_${Date.now()}_${i}`, message: p.message, count: p.count, value: p.value, image: p.image || scratchImageFor(p.message) })),
      totalTries: sTickets,
      remainingTries: sTickets,
      startDate: roToday(),
      endDate: duration === 'none' ? '' : duration === 'month' ? endOfMonthRo() : quickIsoDate(d.days),
      campaignKind: 'scratch',
      receiptScan: bonS,
      voucherValidDays: vDays,
      buttonText: 'Răzuiește!',
      defaultPrizeMsg: 'Ne pare rău, nu ai câștigat de data asta.'
    };
    sStart.disabled = true; sStatus.hidden = false; sStatus.textContent = 'Pregătesc biletele…';
    try {
      const m = await import('./mod-client-modules.js?v=83.79');
      const ok = await m.quickSaveAndStartCampaign(payload, { start: true });
      sStatus.hidden = true;
      if (ok !== false) closeCampSheet();
    } catch (e) {
      sStatus.textContent = e?.message || 'Nu am putut porni campania.';
    } finally { sStart.disabled = false; }
  } }, '🪙 Pornește campania');
  sWrap.append(
    qcEl('span', { class: 'ci-qc__mini', text: 'Premiile' }),
    sList,
    qcEl('div', { class: 'ci-qc__pair ci-qc__pair--3' },
      qcSelect('Bilete', [...new Set([sTickets, 100, 300, 500, 1000, 2000])].sort((x, y) => x - y).map((n) => [n, String(n)]), sTickets, (v) => { sTickets = parseInt(v, 10) || sTickets; drawSummary(); }),
      qcSelect('Durată', durOptions, duration, (v) => { duration = v; }),
      qcSelect('Voucher valabil', VALID_OPTS, vDays, (v) => { vDays = parseInt(v, 10) || 7; })
    ),
    sSummary,
    bonToggle(() => bonS, (v) => { bonS = v; }, 'Un bilet per bon — clientul scanează bonul', 'Fără bon — un bilet per telefon'),
    advancedClaimsBlock(),
    sStatus,
    sStart
  );

  // --- Fereastra pentru Campanie instant / Răzuiește ---
  const popupRoot = getModal() || document.body;
  popupRoot.querySelector('.ci-camp-ov')?.remove();
  const sheetTitle = qcEl('b', { class: 'ci-camp-sheet__title' });
  const sheetBody = qcEl('div', { class: 'ci-camp-sheet__body' });
  const campOv = qcEl('div', { class: 'ci-camp-ov', role: 'dialog', 'aria-modal': 'true' },
    qcEl('div', { class: 'ci-qc ci-camp-sheet' },
      qcEl('div', { class: 'ci-camp-sheet__head' }, sheetTitle, qcEl('button', { type: 'button', class: 'ci-camp-sheet__x', 'aria-label': 'Închide', onclick: () => closeCampSheet() }, '×')),
      sheetBody
    )
  );
  campOv.addEventListener('click', (e) => { if (e.target === campOv) closeCampSheet(); });
  // cardurile de personalizare deschid secțiunile din fereastra mare → închidem foaia și o redeschidem la întoarcere
  rWrap.addEventListener('click', (e) => {
    if (e.target.closest('.ci-modal-picker-card')) { reopenLotterySheet = 'random'; closeCampSheet(); }
  }, true);
  function closeCampSheet() { campOv.classList.remove('is-open'); }
  function openCampSheet(k) {
    const isG = k === 'guaranteed';
    const isL = k === 'lottery';
    const isR = k === 'random';
    sheetTitle.textContent = isG ? `🎁 ${CAMPAIGN_NAMES.guaranteed}` : isL ? `🏆 ${CAMPAIGN_NAMES.lottery}` : isR ? `🍀 ${CAMPAIGN_NAMES.random}` : `🪙 ${CAMPAIGN_NAMES.scratch}`;
    const sh = campOv.querySelector('.ci-camp-sheet');
    sh.classList.toggle('ci-qc--lottery', !isG);
    sh.classList.toggle('ci-camp-sheet--big', isL || isR);
    sheetBody.replaceChildren(isG ? gWrap : isL ? lWrap : isR ? rWrap : sWrap);
    gWrap.hidden = false; sWrap.hidden = false; lWrap.hidden = false; rWrap.hidden = false;
    status.hidden = true; sStatus.hidden = true; lStatus.hidden = true; rStatus.hidden = true;
    campOv.classList.add('is-open');
  }
  popupRoot.appendChild(campOv);

  const kindRow = qcEl('div', { class: 'ci-qc__kinds', role: 'radiogroup', 'aria-label': 'Tip campanie' });
  const KINDS = [
    { k: 'guaranteed', icon: '🎁', name: CAMPAIGN_NAMES.guaranteed, promise: 'Fiecare client primește cadoul pe loc', can: canG, feat: 'campaignGuaranteed' },
    { k: 'scratch', icon: '🪙', name: CAMPAIGN_NAMES.scratch, promise: 'Bilete stabilite dinainte, clientul răzuiește cu degetul', can: canS, feat: 'campaignScratch' },
    { k: 'lottery', icon: '🏆', name: CAMPAIGN_NAMES.lottery, promise: 'Clienții se înscriu, câștigătorii se trag la sorți la final', badge: 'Cu notar', can: canL, feat: 'campaignLottery' }
    // „Campanie aleatorie” (câștig pe loc decis în telefon) a fost retrasă: Răzuiește face același lucru,
    // corect (listă blocată la pornire, art. 47 OG 99/2000). Campaniile vechi de tip „instant” rămân funcționale.
  ];
  const drawKind = () => {
    kindRow.replaceChildren(...KINDS.map((o) => qcEl('button', {
      type: 'button', role: 'radio', 'aria-checked': kind === o.k ? 'true' : 'false',
      class: `ci-qc__kind ci-qc__kind--${o.k}${kind === o.k ? ' is-on' : ''}${o.can ? '' : ' is-locked'}`,
      onclick: () => {
        if (!o.can) { showSnackbar(`🔒 ${featureLockedMessage(o.feat)}`, 'info'); return; }
        // vizitator (demo neactivat): extragerea cere notar și un organizator cu CUI → după activare
        if (o.k === 'lottery' && document.body.classList.contains('sj-visitor-mode')) { showSnackbar('Campania cu extragere se pornește după activarea contului. Până atunci: Campanie instant sau Răzuiește.', 'info'); return; }
        kind = o.k; lastQcKind = o.k; drawKind();
        openCampSheet(o.k);
      }
    },
    qcEl('span', { class: 'ci-qc__kindicon', text: o.icon }),
    qcEl('b', { text: o.name }),
    qcEl('span', { class: 'ci-qc__kindtext', text: o.promise }),
    o.badge || !o.can ? qcEl('em', { class: `ci-qc__badge ci-qc__badge--${o.k}`, text: !o.can ? '🔒 alt plan' : (o.k === 'lottery' && document.body.classList.contains('sj-visitor-mode')) ? '🔒 după activare' : o.badge }) : null,
    o.can ? qcEl('span', { class: 'ci-qc__kindgo', 'aria-hidden': 'true', text: '›' }) : null)));
  };
  box.append(...[
    qcEl('b', { class: 'ci-qc__title', text: 'Ce fel de campanie vrei?' }),
    otherActive ? qcEl('span', { class: 'ci-qc__hint', text: `Acum rulează ${otherActive}. Pornirea campaniei îl oprește (te întrebăm înainte).` }) : null,
    kindRow
  ].filter(Boolean));
  drawKind();
  if (reopenLotterySheet) { const k = reopenLotterySheet === true || reopenLotterySheet === 'random' ? 'lottery' : reopenLotterySheet; reopenLotterySheet = false; openCampSheet(k); }
  return box;
}

function openModalShell() {
  const popup = getModal();
  if (popup) popup.classList.add('active');
  document.body.classList.add('ci-module-popup-open');
}

export function closeClientInterfaceModulePopup() {
  const popup = getModal();
  if (popup) popup.classList.remove('active');
  document.body.classList.remove('ci-module-popup-open');
  modalBackTarget = null;
  setModalBackVisible(false);
  setModalSaveModule(null);
  hideCampanieActivateBar();
  hidePicker();
  restoreAllModalSubsections();
}

/** Alias pentru butoane vechi „Înapoi” din drill-down */
export function closeClientInterfaceDrilldown() {
  closeClientInterfaceModulePopup();
}

export function clientInterfaceModulePopupBack() {
  if (modalBackTarget === 'campanie-picker') {
    showCampaignPicker();
    return;
  }
  closeClientInterfaceModulePopup();
}

function openSubsectionInModal(subsectionId, options = {}) {
  const id = String(subsectionId || '').trim();
  if (!id) return;

  const sub = findSubsection(id);
  if (!sub) {
    logger.warn('[client-interface-nav] Subsection not found:', id);
    return;
  }

  restoreAllModalSubsections();
  hidePicker();

  const body = getModalBody();
  if (!body) return;

  rememberSubsectionHome(sub);
  sub.classList.add('expanded', 'ci-in-modal');
  body.appendChild(sub);
  body.classList.add('has-subsection');

  if (getModalTitleEl()) {
    getModalTitleEl().textContent = moduleTitleFor(id);
  }
  setModalModuleIcon(id);

  modalBackTarget = options.fromCampaniePicker ? 'campanie-picker' : null;
  setModalBackVisible(!!modalBackTarget);
  if (options.fromCampaniePicker) {
    showCampanieActivateBar();
  } else if (id === 'loyalty-module' || id === 'event-module') {
    hideCampanieActivateBar();
    import('./mod-client-modules.js?v=83.79')
      .then((m) => m.updateModClientModulesUI?.())
      .catch(() => {});
  } else {
    hideCampanieActivateBar();
  }
  if (options.hideGlobalSave || id === 'loyalty-module' || id === 'event-module') {
    setModalSaveModule(null);
  } else {
    setModalSaveModule(id);
  }

  openModalShell();

  if (id === 'client-promo-gallery') {
    try {
      hydrateClientPromoGalleryAdminFromSettings();
      syncClientPromoFieldsVisibility();
    } catch (e) {
      logger.warn('[client-interface-nav] syncClientPromoFieldsVisibility failed:', e);
    }
  }

  if (id === 'location-menu') {
    import('./menu-module-admin.js?v=83.79')
      .then((m) => m.hydrateMenuModuleAdminFromSettings())
      .catch((e) => logger.warn('[client-interface-nav] hydrateMenuModule failed:', e));
  }

  if (id === 'reservation') {
    import('./contact-module-admin.js?v=83.79')
      .then((m) => m.hydrateContactModuleAdminFromSettings())
      .catch((e) => logger.warn('[client-interface-nav] hydrateContactModule failed:', e));
  }

  body.scrollTop = 0;
}

const MODULE_FEATURE = { campanie: 'campaignLottery', fidelizare: 'loyalty', eveniment: 'events' };

export async function openClientInterfaceModule(moduleId) {
  const id = String(moduleId || '').trim().toLowerCase();
  if (id === 'campanie') {
    const { ensureAnyFeature } = await import('../config/plans.js?v=83.79');
    if (!(await ensureAnyFeature(['campaignGuaranteed', 'campaignLottery']))) return;
  } else if (MODULE_FEATURE[id]) {
    const { ensureFeature } = await import('../config/plans.js?v=83.79');
    if (!(await ensureFeature(MODULE_FEATURE[id]))) return;
  }
  if (id === 'campanie') {
    openModalShell();
    showCampaignPicker();
    return;
  }
  if (id === 'eveniment') {
    openSubsectionInModal('event-module', { hideGlobalSave: true });
    return;
  }
  if (id === 'fidelizare') {
    import('./loyalty-module-admin.js?v=83.79')
      .then((m) => m.loadLoyaltySettingsIntoForm())
      .catch(() => {});
    openSubsectionInModal('loyalty-module', { hideGlobalSave: true });
    return;
  }
  logger.warn('[client-interface-nav] Unknown module:', moduleId);
}

export function openClientInterfaceSubsection(subsectionId) {
  const id = String(subsectionId || '').trim();
  const picker = getModalPicker();
  const fromCampaniePicker =
    !!picker && !picker.hidden && CAMPAIGN_PICKER_ITEMS.some((item) => item.id === id);
  openSubsectionInModal(id, { fromCampaniePicker });
}

export function openClientInterfaceEditableSection(sectionKey) {
  const key = String(sectionKey || '').trim();
  const mapped = EDITABLE_SECTION_MAP[key];
  if (mapped) {
    openClientInterfaceSubsection(mapped);
    return;
  }
  const labels = {
    bannere: 'Bannere',
    oferte: 'Oferte',
    'evenimente-edit': 'Evenimente',
    continut: 'Conținut personalizat'
  };
  showSnackbar(
    `„${labels[key] || 'Secțiunea'}” va fi configurabilă în curând.`,
    'info'
  );
}

export function getClientInterfaceSubsectionScope() {
  const popup = getModal();
  const body = getModalBody();
  if (popup?.classList.contains('active') && body) {
    const inModal = body.querySelector('.admin-subsection.ci-in-modal');
    if (inModal) return inModal;
    return body;
  }

  const section = document.querySelector('.admin-section[data-section="client-interface"]');
  if (!section) return null;

  const panels = getPanelsRoot();
  if (panels) return panels;

  return section;
}
